module.exports = __webpack_public_path__ + "static/media/34_tn.0ead64bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/34_tn.jpg
// module id = 172
// module chunks = 0